import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PlayListIntegrated = ({ language, token }) => {
  const { state } = useLocation();
  useEffect(() => {
    if (state?.id) {
      const el = document.getElementById("iframe_playlist_display");
      el.contentWindow.postMessage({
        info: "editPlaylist",
        value: state?.id,
      });
    }
    return window.history.replaceState({}, document.title)
  }, [state]);

    const newPlayListIframe = "https:" +
    window.process.env.URL_Media + "/playlist" + 
    "?lang=" +
    language +
    "&token=" +
    token +
    (state?.id
      ? `&editId=${state.id}`
      : "");

  return (
    <iframe
      id="iframe_playlist_display"
      src={newPlayListIframe}
      allowFullScreen
      frameBorder={"0"}
      style={{ width: "100%", height: "98%", overflow: "hidden" }}
    />
  );
};

export default PlayListIntegrated;
